<template>
  <div class="meeting-mentor-report container-fluid">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <meeting-mentor-report-tab @clickedTab="selectedTab"></meeting-mentor-report-tab>
      <report-start-end-date-group-cohort-filter-bar @selectedEndDate="setEndDate" @selectedStartDate="setStartDate" @selectedGroupObj="setGroupObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="currentSelectedTab === 4"></report-start-end-date-group-cohort-filter-bar>
      <meeting-mentor-report-bar @selectedGroupObj="setGroupObj" @selectedCohortObj="setCohortObj" :currentSelectedTab="currentSelectedTab" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-else></meeting-mentor-report-bar>
      <hr width="97%" size="10px">
      <div class="row margin-Top-2Perc">
        <div class="col-md-11 col-lg-11 width margin-left-0point4Perc">
          <sortable-list v-if="showMeetingMentorReportList" v-bind:responseObj="getCurrSelectedTabReportRespArr" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="10"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>      
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>       
  </div>  
</template>

<script>
import MeetingMentorReportFilterBar from '@/components/MeetingMentorReportFilterBar'
// import ReportGroupFilterBar from '@/components/ReportGroupFilterBar'
import list from '@/pages/SortableList'
import CopyrightElement from '@/components/CopyrightElement'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import AlertBox from '@/components/AlertOverlay'
import csvHelper from '@/utils/csv-helper'
import ErrorPage from '@/pages/Error'
import Loader from '@/components/dashboard/Loader'
import { participantService } from '@/server-util/participant-service'
import MeetingMentorReportTab from '../components/MeetingMentorReportTab'
import ReportStartEndDateGroupCohortFilterBar from '@/components/ReportStartEndDateGroupCohortFilterBar'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      currentSelectedTab: 1,
      showMeetingMentorReportList: false,
      selectedGroupObj: null,
      selectedCohortObj: null,
      showExportButton: true,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      currSelectedTabReportRespArr: [],
      sortColumnNames: [],
      columnAlias: [],
      columnRespKey: [],
      columnRespKeyForExport: [],
      columnNameToShow: [],
      linkColumnNames: [],
      isExportBtnClicked: false,
      isViewBtnClicked: false,
      startDate: '',
      endDate: ''
    }
  },
  components: {
    'meeting-mentor-report-tab': MeetingMentorReportTab,
    'meeting-mentor-report-bar': MeetingMentorReportFilterBar,
    'report-start-end-date-group-cohort-filter-bar': ReportStartEndDateGroupCohortFilterBar,
    'Copyright-Element': CopyrightElement,
    'sortable-list': list,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    selectedTab (value) {
      if (this.currentSelectedTab !== parseInt(value)) {
        // AK: If user changed Tab then do not show list and reset view and export btn flag to false
        this.showMeetingMentorReportList = false
        this.selectedGroupObj = null
        this.selectedCohortObj = null
      }
      this.currentSelectedTab = parseInt(value)
      switch (this.currentSelectedTab) {
        case 2:
          this.startDate = moment().tz('America/New_York').add(-7, 'days').format('MM/DD/YYYY')
          this.endDate = moment().tz('America/New_York').format('MM/DD/YYYY')
          break
        default:
          break
      }
      if (!isEmpty(this.selectedGroupObj) && !isEmpty(this.selectedCohortObj)) {
        this.updateViewBtnClickedFlag(true)
      }
    },
    setStartDate (value) {
      // AK: When user selected startDate then update it in parent file too
      this.startDate = value
    },
    setEndDate (value) {
      // AK: When user selected endDate then update it in parent file too
      this.endDate = value
    },
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    setGroupObj (value) {
      // AK: When user selected particular group object then update it in parent file too
      this.selectedGroupObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getGoalActionReport()
            break
          case 2:
            this.getMeetingMentorReport()
            break
          case 3:
            this.getMMReviewReport()
            break
          case 4:
            this.getMMConsolidatedReport()
            break
        }
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getGoalActionReport()
            break
          case 2:
            this.getMeetingMentorReport()
            break
          case 3:
            this.getMMReviewReport()
            break
          case 4:
            this.getMMConsolidatedReport()
            break
        }
      }
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
    },
    getGoalActionReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '') {
        this.$store.state.isLoading = true
        reportService.getMeetingMentorGoalActionsData(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.currSelectedTabReportRespArr = responseObj.data
              if (parseInt(_this.currSelectedTabReportRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No Goal Action report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showMeetingMentorReportList = false
              } else {
                this.checkAndProccessResp()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('GROUP ID is NULL hence declined LOADING GOAL ACTION LIST')
      }
    },
    getMMConsolidatedReport: function () {
      var storeObj = this.$store
      var _this = this
      if (Date.parse(_this.startDate) > Date.parse(_this.endDate)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date must be less than the end date.'
        return
      }
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '') {
        this.$store.state.isLoading = true
        reportService.getMMConsolidatedReport(storeObj.state.access_token, _this.selectedCohortObj.CohortId, this.startDate, this.endDate).then(
        // reportService.getMMConsolidatedReport(storeObj.state.access_token, '673d54d5-80ab-4f5d-94b4-14923c26e240', '11/1/2022', '11/17/2022').then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.currSelectedTabReportRespArr = responseObj.data
              if (parseInt(_this.currSelectedTabReportRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No Consolidated report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showMeetingMentorReportList = false
              } else {
                this.checkAndProccessResp()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('GROUP ID is NULL hence declined LOADING REVIEW LIST')
      }
    },
    getMMReviewReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '') {
        this.$store.state.isLoading = true
        reportService.getReviewReport(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.currSelectedTabReportRespArr = responseObj.data
              if (parseInt(_this.currSelectedTabReportRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No Reivew report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showMeetingMentorReportList = false
              } else {
                this.checkAndProccessResp()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('GROUP ID is NULL hence declined LOADING REVIEW LIST')
      }
    },
    getMeetingMentorReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '') {
        this.$store.state.isLoading = true
        reportService.getMeetingMentorReport(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.currSelectedTabReportRespArr = responseObj.data
              if (parseInt(_this.currSelectedTabReportRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No Meeting Mentor report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showMeetingMentorReportList = false
              } else {
                this.checkAndProccessResp()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('GROUP ID is NULL hence declined LOADING GOAL ACTION LIST')
      }
    },
    convertToHoursMinsSeconds: function (durationInSeconds) {
      return moment().startOf('day').seconds(durationInSeconds).format('HH:mm:ss')
    },
    convertToHtmlForm: function (strToFormat) {
      const splitStr = strToFormat.split('||')
      var htmlToReturn = '<span>'
      for (var i = 0; i < splitStr.length; i++) {
        htmlToReturn += (i + 1) + '.' + splitStr[i] + '<br/>'
      }
      htmlToReturn += '</span>'
      return htmlToReturn
    },
    convertToPlainForm: function (strToFormat) {
      const splitStr = strToFormat.split('||')
      var htmlToReturn = ''
      for (var i = 0; i < splitStr.length; i++) {
        htmlToReturn += (i + 1) + '.' + splitStr[i] + '     '
      }
      htmlToReturn += ''
      return htmlToReturn
    },
    convertUserMeditationRespToHtmlForm: function (jsonStr) {
      var htmlToReturn = '<span>'
      for (var i = 0; i < jsonStr.length; i++) {
        htmlToReturn += (i + 1) + '. ' + jsonStr[i].MeditationTitle + ' - '
        htmlToReturn += (jsonStr[i].CompletedCount > 0) ? '<b> Completed [' + jsonStr[i].CompletedCount + ']</b>' : '<b> View [' + jsonStr[i].ViewCount + ']</b>'
        htmlToReturn += '<br/>'
      }
      htmlToReturn += '</span>'
      return htmlToReturn
    },
    convertUserMeditationRespToPlainForm: function (jsonStr) {
      var plainTextToReturn = ''
      for (var i = 0; i < jsonStr.length; i++) {
        plainTextToReturn += (i + 1) + '. ' + jsonStr[i].MeditationTitle + ' - '
        plainTextToReturn += (jsonStr[i].CompletedCount > 0) ? ' Completed [' + jsonStr[i].CompletedCount + ']' : ' View [' + jsonStr[i].ViewCount + ']'
        plainTextToReturn += '     '
      }
      plainTextToReturn += ''
      return plainTextToReturn
    },
    convertUserReviewActionRespToHtmlForm: function (jsonStr) {
      var htmlToReturn = '<span>'
      for (var i = 0; i < jsonStr.length; i++) {
        htmlToReturn += (i + 1) + '. ' + jsonStr[i].ActionName
        switch (parseInt(jsonStr[i].ActionRating)) {
          case 1:
            htmlToReturn += ' <b>[Did not Use]</b>'
            break
          case 2:
            htmlToReturn += ' <b>[Somewhat Effective]</b>'
            break
          case 3:
            htmlToReturn += ' <b>[Very Effective]</b>'
            break
        }
        htmlToReturn += '<br/>'
      }
      htmlToReturn += '</span>'
      return htmlToReturn
    },
    convertUserReviewActionRespToPlainForm: function (jsonStr) {
      var plainTextToReturn = ''
      for (var i = 0; i < jsonStr.length; i++) {
        plainTextToReturn += (i + 1) + '. ' + jsonStr[i].ActionName
        switch (parseInt(jsonStr[i].ActionRating)) {
          case 1:
            plainTextToReturn += ' [Did not Use]'
            break
          case 2:
            plainTextToReturn += ' [Somewhat Effective]'
            break
          case 3:
            plainTextToReturn += ' [Very Effective]'
            break
        }
        plainTextToReturn += '     '
      }
      return plainTextToReturn
    },
    convertUserMeetingFeedbackRespToHtmlForm: function (jsonStr) {
      var htmlToReturn = '<span>'
      for (var i = 0; i < jsonStr.length; i++) {
        htmlToReturn += '<b>Que. ' + (i + 1) + ': ' + jsonStr[i].QuestionText + '</b>'
        htmlToReturn += '<br/>'
        htmlToReturn += 'Ans ' + (i + 1) + ': ' + jsonStr[i].Feedback
        htmlToReturn += '<br/><br/>'
      }
      htmlToReturn += '</span>'
      return htmlToReturn
    },
    convertUserMeetingFeedbackRespToPlainForm: function (jsonStr) {
      var plainTextToReturn = ''
      for (var i = 0; i < jsonStr.length; i++) {
        plainTextToReturn += 'Que. ' + (i + 1) + ': ' + jsonStr[i].QuestionText + ''
        plainTextToReturn += '     '
        plainTextToReturn += 'Ans: ' + jsonStr[i].Feedback
        plainTextToReturn += '     '
      }
      return plainTextToReturn
    },
    checkAndProccessResp: function () {
      switch (this.currentSelectedTab) {
        case 1:
          this.sortColumnNames = ['UserFullName', 'EmailId', 'GoalName', 'Attempt']
          this.columnAlias = ['Full Name', 'Email Id', 'Selected Goal', '# of Attempt', 'Recommended Actions', 'Actions Picked', 'Affirmation Attempt Type', 'Affirmations Picked', 'Intention Attempt Type', 'Meditations Attempt Status']
          this.columnRespKey = ['UserFullName', 'EmailId', 'GoalName', 'Attempt', 'RecommendedActions', 'ActionsUsed', 'AffirmationAttemptType', 'SelectedAffirmations', 'IntentionAttemptType', 'UserMeditation']
          this.columnRespKeyForExport = ['UserFullName', 'EmailId', 'GoalName', 'Attempt', 'RecommendedActionsForExport', 'ActionsUsedForExport', 'AffirmationAttemptType', 'SelectedAffirmationsForExport', 'IntentionAttemptType', 'UserMeditationForExport']
          this.csvFileName = 'GoalsActionsReport(' + this.selectedGroupObj.GroupName + '-' + this.selectedCohortObj.CohortName + ')'
          for (var i = 0; i < this.currSelectedTabReportRespArr.length; i++) {
            const recommendedActions = this.currSelectedTabReportRespArr[i].RecommendedActions
            this.currSelectedTabReportRespArr[i].RecommendedActions = (recommendedActions !== undefined && recommendedActions !== 'undefined' && recommendedActions !== null && recommendedActions !== 'null' && recommendedActions !== '') ? this.convertToHtmlForm(recommendedActions) : 'Not Found'
            this.currSelectedTabReportRespArr[i].RecommendedActionsForExport = (recommendedActions !== undefined && recommendedActions !== 'undefined' && recommendedActions !== null && recommendedActions !== 'null' && recommendedActions !== '') ? this.convertToPlainForm(recommendedActions) : 'Not Found'
            const actionsUsed = this.currSelectedTabReportRespArr[i].ActionsUsed
            this.currSelectedTabReportRespArr[i].ActionsUsed = (actionsUsed !== undefined && actionsUsed !== 'undefined' && actionsUsed !== null && actionsUsed !== 'null' && actionsUsed !== '') ? this.convertToHtmlForm(actionsUsed) : 'Not Found'
            this.currSelectedTabReportRespArr[i].ActionsUsedForExport = (actionsUsed !== undefined && actionsUsed !== 'undefined' && actionsUsed !== null && actionsUsed !== 'null' && actionsUsed !== '') ? this.convertToPlainForm(actionsUsed) : 'Not Found'
            const previouslyUsedActions = this.currSelectedTabReportRespArr[i].PreviouslyUsedActions
            this.currSelectedTabReportRespArr[i].PreviouslyUsedActions = (previouslyUsedActions !== undefined && previouslyUsedActions !== 'undefined' && previouslyUsedActions !== null && previouslyUsedActions !== 'null' && previouslyUsedActions !== '') ? this.convertToHtmlForm(previouslyUsedActions) : 'Not Found'
            this.currSelectedTabReportRespArr[i].PreviouslyUsedActionsForExport = (previouslyUsedActions !== undefined && previouslyUsedActions !== 'undefined' && previouslyUsedActions !== null && previouslyUsedActions !== 'null' && previouslyUsedActions !== '') ? this.convertToPlainForm(previouslyUsedActions) : 'Not Found'
            const affirmations = this.currSelectedTabReportRespArr[i].Affirmations
            this.currSelectedTabReportRespArr[i].Affirmations = (affirmations !== undefined && affirmations !== 'undefined' && affirmations !== null && affirmations !== 'null' && affirmations !== '') ? this.convertToHtmlForm(affirmations) : 'Not Found'
            this.currSelectedTabReportRespArr[i].AffirmationsForExport = (affirmations !== undefined && affirmations !== 'undefined' && affirmations !== null && affirmations !== 'null' && affirmations !== '') ? this.convertToPlainForm(affirmations) : 'Not Found'
            const selectedAffirmation = this.currSelectedTabReportRespArr[i].SelectedAffirmations
            this.currSelectedTabReportRespArr[i].SelectedAffirmations = (selectedAffirmation !== undefined && selectedAffirmation !== 'undefined' && selectedAffirmation !== null && selectedAffirmation !== 'null' && selectedAffirmation !== '') ? this.convertToHtmlForm(selectedAffirmation) : 'Not Attempted'
            this.currSelectedTabReportRespArr[i].SelectedAffirmationsForExport = (selectedAffirmation !== undefined && selectedAffirmation !== 'undefined' && selectedAffirmation !== null && selectedAffirmation !== 'null' && selectedAffirmation !== '') ? this.convertToPlainForm(selectedAffirmation) : 'Not Attempted'
            if (this.currSelectedTabReportRespArr[i].UserMeditation !== undefined && this.currSelectedTabReportRespArr[i].UserMeditation !== 'undefined' && this.currSelectedTabReportRespArr[i].UserMeditation !== null && this.currSelectedTabReportRespArr[i].UserMeditation !== 'null' && this.currSelectedTabReportRespArr[i].UserMeditation !== '' && this.currSelectedTabReportRespArr[i].UserMeditation.length !== 0) {
              this.currSelectedTabReportRespArr[i].UserMeditationForExport = this.convertUserMeditationRespToPlainForm(this.currSelectedTabReportRespArr[i].UserMeditation)
              this.currSelectedTabReportRespArr[i].UserMeditation = this.convertUserMeditationRespToHtmlForm(this.currSelectedTabReportRespArr[i].UserMeditation)
            } else {
              this.currSelectedTabReportRespArr[i].UserMeditation = 'Not Attempted'
              this.currSelectedTabReportRespArr[i].UserMeditationForExport = 'Not Attempted'
            }
          }
          break
        case 2:
          this.columnAlias = ['Full Name', 'Email Id', 'Selected Goal', '# of Attempt', 'Selected Calender', 'Actual Meeting Name', 'Actual Meeting Time', 'Scheduled Prep Time', 'Scheduled Prep Duration', 'Scheduled Review Time', 'Scheduled Review Duration', 'Attempted Prep', 'Attempted Prep Time', 'Attempted Prep Duration', 'Completed Review', 'Meeting CreatedTS']
          this.columnRespKey = ['UserFullName', 'EmailId', 'SelectedGoal', 'Attempt', 'SelectedCalender', 'ActualMeetingName', 'ActualMeetingTime', 'ScheduledPrepTime', 'ScheduledPrepDuration', 'ScheduledReviewTime', 'ScheduledReviewDuration', 'AttemptedPrep', 'AttemptedPrepTime', 'AttemptedPrepDuration', 'CompletedReview', 'MeetingCreatedTs']
          this.columnRespKeyForExport = ['UserFullName', 'EmailId', 'SelectedGoal', 'Attempt', 'SelectedCalender', 'ActualMeetingName', 'ActualMeetingTime', 'ScheduledPrepTime', 'ScheduledPrepDuration', 'ScheduledReviewTime', 'ScheduledReviewDuration', 'AttemptedPrep', 'AttemptedPrepTime', 'AttemptedPrepDuration', 'CompletedReview', 'MeetingCreatedTs']
          this.sortColumnNames = ['UserFullName', 'EmailId', 'SelectedGoal', 'Attempt', 'SelectedCalender', 'AttemptedPrep', 'AttemptPrepTime']
          this.csvFileName = 'MeetingMentorReport(' + this.selectedGroupObj.GroupName + '-' + this.selectedCohortObj.CohortName + ')'
          for (i = 0; i < this.currSelectedTabReportRespArr.length; i++) {
            this.currSelectedTabReportRespArr[i].AttemptedPrepDuration = (this.currSelectedTabReportRespArr[i].AttemptedPrepDuration !== undefined && this.currSelectedTabReportRespArr[i].AttemptedPrepDuration !== 'undefined' && this.currSelectedTabReportRespArr[i].AttemptedPrepDuration !== null && this.currSelectedTabReportRespArr[i].AttemptedPrepDuration !== 'null' && this.currSelectedTabReportRespArr[i].AttemptedPrepDuration !== '') ? this.convertToHoursMinsSeconds(this.currSelectedTabReportRespArr[i].AttemptedPrepDuration) : '00:00:00'
          }
          break
        case 3:
          this.columnAlias = ['Full Name', 'Email Id', 'Selected Goal', '# of Attempt', 'Were you able to achieve your goal at the meeting?', 'Which of these actions did you use at the meeting, and how effective were you at using them?', 'Feedback']
          this.columnRespKey = ['UserFullName', 'EmailId', 'GoalName', 'Attempt', 'UserChallengeRating', 'UserActionReview', 'UserMeetingFeedbackObject']
          this.columnRespKeyForExport = ['UserFullName', 'EmailId', 'GoalName', 'Attempt', 'UserChallengeRating', 'UserActionReviewForExport', 'UserMeetingFeedbackObjectForExport']
          this.sortColumnNames = ['UserFullName', 'EmailId', 'GoalName', 'Attempt', 'UserChallengeRating']
          this.csvFileName = 'MeetingMentorReviewReport(' + this.selectedGroupObj.GroupName + '-' + this.selectedCohortObj.CohortName + ')'
          for (i = 0; i < this.currSelectedTabReportRespArr.length; i++) {
            this.currSelectedTabReportRespArr[i].UserChallengeRating = this.getUserChallengeRatingInText(this.currSelectedTabReportRespArr[i].UserChallengeRating)
            if (this.currSelectedTabReportRespArr[i].UserActionReview !== undefined && this.currSelectedTabReportRespArr[i].UserActionReview !== 'undefined' && this.currSelectedTabReportRespArr[i].UserActionReview !== null && this.currSelectedTabReportRespArr[i].UserActionReview !== 'null' && this.currSelectedTabReportRespArr[i].UserActionReview !== '' && this.currSelectedTabReportRespArr[i].UserActionReview.length !== 0) {
              this.currSelectedTabReportRespArr[i].UserActionReviewForExport = this.convertUserReviewActionRespToPlainForm(this.currSelectedTabReportRespArr[i].UserActionReview)
              this.currSelectedTabReportRespArr[i].UserActionReview = this.convertUserReviewActionRespToHtmlForm(this.currSelectedTabReportRespArr[i].UserActionReview)
            } else {
              this.currSelectedTabReportRespArr[i].UserActionReview = 'Not Attempted'
              this.currSelectedTabReportRespArr[i].UserActionReviewForExport = 'Not Attempted'
            }
            if (this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject !== undefined && this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject !== 'undefined' && this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject !== null && this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject !== 'null' && this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject !== '' && this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject.length !== 0) {
              this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObjectForExport = this.convertUserMeetingFeedbackRespToPlainForm(this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject)
              this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject = this.convertUserMeetingFeedbackRespToHtmlForm(this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject)
            } else {
              this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObject = 'Not Attempted'
              this.currSelectedTabReportRespArr[i].UserMeetingFeedbackObjectForExport = 'Not Attempted'
            }
          }
          break
        case 4:
          this.columnAlias = ['Name', 'Email Id', 'Login Status', 'Meeting Title', 'Meeting Mentor Launched?', 'MM Launch Count', 'Selected Calendar', 'Scheduled Meeting', 'Attempted Prep', 'Prep Launch Count', 'Prep View Duration', 'Completed Review', 'Scheduled Meeting TS', 'Selected Goal', '# Attempt', 'Recommended Actions', 'Actions Added', 'Actions Removed', 'Final Actions Selected', 'Actions Toolkit View Count - Setup', 'Actions Toolkit View Count - Prep', 'Affirmation Attempt Type', 'Affirmations Picked', 'Written Affirmations', 'Intention Attempt Type', 'Intentions Picked', 'Written Intentions', 'Meditations', 'Meditations Status', 'Meditations View Count', 'Past Meeting Reviewed', 'Were you able to achieve your goal at the meeting?', 'Which of these actions did you use at the meeting, and how effective were you at using them? (from Review)', 'Feedback']
          this.columnRespKey = ['Name', 'EmailId', 'LoginStatus', 'MeetingTitle', 'MeetingMentorLaunched', 'MeetingMentorLaunchedCount', 'SelectedCalendar', 'ScheduledMeeting', 'AttemptedPrep', 'AttemptPrepCount', 'AttemptPrepDuration', 'CompletedReview', 'ScheduledMeetingTS', 'SelectedGoal', 'Attempt', 'RecommendedActions', 'ActionsAdded', 'ActionsRemoved', 'ActionsPicked', 'ActionToolkitViewedDuringSetup', 'ActionToolkitViewedDuringPrep', 'AffirmationAttemptType', 'AffirmationsPicked', 'AffirmationsWritten', 'IntentionAttemptType', 'IntentionsPicked', 'IntentionsWritten', 'Meditation', 'MeditationAttemptStatus', 'MeditationViewedDuringMeeting', 'PastMeetingReviewedForSameGoal', 'Wereyouabletoachieveyourgoalatthemeeting', 'Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem', 'Feedback']
          this.columnRespKeyForExport = ['Name', 'EmailId', 'LoginStatus', 'MeetingTitle', 'MeetingMentorLaunched', 'MeetingMentorLaunchedCount', 'SelectedCalendar', 'ScheduledMeeting', 'AttemptedPrep', 'AttemptPrepCount', 'AttemptPrepDuration', 'CompletedReview', 'ScheduledMeetingTS', 'SelectedGoal', 'Attempt', 'RecommendedActions', 'ActionsAdded', 'ActionsRemoved', 'ActionsPicked', 'ActionToolkitViewedDuringSetup', 'ActionToolkitViewedDuringPrep', 'AffirmationAttemptType', 'AffirmationsPicked', 'AffirmationsWritten', 'IntentionAttemptType', 'IntentionsPicked', 'IntentionsWritten', 'Meditation', 'MeditationAttemptStatus', 'MeditationViewedDuringMeeting', 'PastMeetingReviewedForSameGoal', 'Wereyouabletoachieveyourgoalatthemeeting', 'WhichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthemForExport', 'FeedbackForExport']
          this.sortColumnNames = ['Name', 'EmailId', 'LoginStatus', 'MeetingTitle', 'MeetingMentorLaunched', 'MeetingMentorLaunchedCount', 'SelectedCalendar', 'AttemptedPrep', 'SelectedGoal', 'Attempt', 'MeditationAttemptStatus', 'Feedback']
          this.csvFileName = 'MeetingMentorConsolidatedReport(' + this.selectedGroupObj.GroupName + '-' + this.selectedCohortObj.CohortName + ')'
          for (i = 0; i < this.currSelectedTabReportRespArr.length; i++) {
            if (this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== undefined && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== 'undefined' && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== null && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== 'null' && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== '' && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem.length !== 0) {
              this.currSelectedTabReportRespArr[i].WhichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthemForExport = this.convertUserReviewActionRespToPlainForm(this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem)
              this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem = this.convertUserReviewActionRespToHtmlForm(this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem)
            } else {
              this.currSelectedTabReportRespArr[i].WhichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthemForExport = 'Not Attempted'
              this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem = 'Not Attempted'
            }
            if (this.currSelectedTabReportRespArr[i].Feedback !== undefined && this.currSelectedTabReportRespArr[i].Feedback !== 'undefined' && this.currSelectedTabReportRespArr[i].Feedback !== null && this.currSelectedTabReportRespArr[i].Feedback !== 'null' && this.currSelectedTabReportRespArr[i].Feedback !== '' && this.currSelectedTabReportRespArr[i].Feedback.length !== 0) {
              this.currSelectedTabReportRespArr[i].FeedbackForExport = this.convertUserMeetingFeedbackRespToPlainForm(this.currSelectedTabReportRespArr[i].Feedback)
              this.currSelectedTabReportRespArr[i].Feedback = this.convertUserMeetingFeedbackRespToHtmlForm(this.currSelectedTabReportRespArr[i].Feedback)
            } else {
              this.currSelectedTabReportRespArr[i].Feedback = 'Not Attempted'
              this.currSelectedTabReportRespArr[i].FeedbackForExport = 'Not Attempted'
            }
            this.currSelectedTabReportRespArr[i].AffirmationsWritten = (this.currSelectedTabReportRespArr[i].AffirmationsWritten !== undefined && this.currSelectedTabReportRespArr[i].AffirmationsWritten !== 'undefined' && this.currSelectedTabReportRespArr[i].AffirmationsWritten !== null && this.currSelectedTabReportRespArr[i].AffirmationsWritten !== 'null' && this.currSelectedTabReportRespArr[i].AffirmationsWritten !== '') ? this.currSelectedTabReportRespArr[i].AffirmationsWritten : 'Not Found'
            this.currSelectedTabReportRespArr[i].IntentionsWritten = (this.currSelectedTabReportRespArr[i].IntentionsWritten !== undefined && this.currSelectedTabReportRespArr[i].IntentionsWritten !== 'undefined' && this.currSelectedTabReportRespArr[i].IntentionsWritten !== null && this.currSelectedTabReportRespArr[i].IntentionsWritten !== 'null' && this.currSelectedTabReportRespArr[i].IntentionsWritten !== '') ? this.currSelectedTabReportRespArr[i].IntentionsWritten : 'Not Found'
            this.currSelectedTabReportRespArr[i].ActionsAdded = (this.currSelectedTabReportRespArr[i].ActionsAdded !== undefined && this.currSelectedTabReportRespArr[i].ActionsAdded !== 'undefined' && this.currSelectedTabReportRespArr[i].ActionsAdded !== null && this.currSelectedTabReportRespArr[i].ActionsAdded !== 'null' && this.currSelectedTabReportRespArr[i].ActionsAdded !== '') ? this.currSelectedTabReportRespArr[i].ActionsAdded : 'Not Found'
            this.currSelectedTabReportRespArr[i].ActionsRemoved = (this.currSelectedTabReportRespArr[i].ActionsRemoved !== undefined && this.currSelectedTabReportRespArr[i].ActionsRemoved !== 'undefined' && this.currSelectedTabReportRespArr[i].ActionsRemoved !== null && this.currSelectedTabReportRespArr[i].ActionsRemoved !== 'null' && this.currSelectedTabReportRespArr[i].ActionsRemoved !== '') ? this.currSelectedTabReportRespArr[i].ActionsRemoved : 'Not Found'
            this.currSelectedTabReportRespArr[i].PastMeetingReviewedForSameGoal = (this.currSelectedTabReportRespArr[i].PastMeetingReviewedForSameGoal !== undefined && this.currSelectedTabReportRespArr[i].PastMeetingReviewedForSameGoal !== 'undefined' && this.currSelectedTabReportRespArr[i].PastMeetingReviewedForSameGoal !== null && this.currSelectedTabReportRespArr[i].PastMeetingReviewedForSameGoal !== 'null' && this.currSelectedTabReportRespArr[i].PastMeetingReviewedForSameGoal !== '') ? (this.currSelectedTabReportRespArr[i].PastMeetingReviewedForSameGoal ? 'Yes' : 'No') : 'Not Found'
            this.currSelectedTabReportRespArr[i].MeditationViewedDuringMeeting = (this.currSelectedTabReportRespArr[i].MeditationViewedDuringMeeting !== undefined && this.currSelectedTabReportRespArr[i].MeditationViewedDuringMeeting !== 'undefined' && this.currSelectedTabReportRespArr[i].MeditationViewedDuringMeeting !== null && this.currSelectedTabReportRespArr[i].MeditationViewedDuringMeeting !== 'null' && this.currSelectedTabReportRespArr[i].MeditationViewedDuringMeeting !== '') ? this.currSelectedTabReportRespArr[i].MeditationViewedDuringMeeting : 'Not Attempted'
            this.currSelectedTabReportRespArr[i].AttemptPrepDuration = (this.currSelectedTabReportRespArr[i].AttemptPrepDuration) > 0 ? dmAdminUtils.convertSecondsToMinFormat(this.currSelectedTabReportRespArr[i].AttemptPrepDuration, false) : 'Not Found'
            this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringSetup = (this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringSetup !== undefined && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringSetup !== 'undefined' && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringSetup !== null && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringSetup !== 'null' && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringSetup !== '' && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringSetup.length !== 0) ? this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringSetup : 'Not Found'
            this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringPrep = (this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringPrep !== undefined && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringPrep !== 'undefined' && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringPrep !== null && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringPrep !== 'null' && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringPrep !== '' && this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringPrep.length !== 0) ? this.currSelectedTabReportRespArr[i].ActionToolkitViewedDuringPrep : 'Not Found'
            this.currSelectedTabReportRespArr[i].MeetingMentorLaunchedCount = this.currSelectedTabReportRespArr[i].MeetingMentorLaunched
            this.currSelectedTabReportRespArr[i].MeetingMentorLaunched = this.currSelectedTabReportRespArr[i].MeetingMentorLaunched > 0 ? 'Yes' : 'No'
            this.currSelectedTabReportRespArr[i].LoginStatus = this.currSelectedTabReportRespArr[i].LoginStatus ? 'Yes' : 'No'
            this.currSelectedTabReportRespArr[i].SelectedCalendar = this.currSelectedTabReportRespArr[i].SelectedCalendar ? 'Yes' : 'No'
            this.currSelectedTabReportRespArr[i].ScheduledMeeting = this.currSelectedTabReportRespArr[i].ScheduledMeeting ? 'Yes' : 'No'
            this.currSelectedTabReportRespArr[i].RecommendedActions = (this.currSelectedTabReportRespArr[i].RecommendedActions !== undefined && this.currSelectedTabReportRespArr[i].RecommendedActions !== 'undefined' && this.currSelectedTabReportRespArr[i].RecommendedActions !== null && this.currSelectedTabReportRespArr[i].RecommendedActions !== 'null' && this.currSelectedTabReportRespArr[i].RecommendedActions !== '' && this.currSelectedTabReportRespArr[i].RecommendedActions.length !== 0) ? this.currSelectedTabReportRespArr[i].RecommendedActions : 'Not Found'
            this.currSelectedTabReportRespArr[i].AffirmationsPicked = (this.currSelectedTabReportRespArr[i].AffirmationsPicked !== undefined && this.currSelectedTabReportRespArr[i].AffirmationsPicked !== 'undefined' && this.currSelectedTabReportRespArr[i].AffirmationsPicked !== null && this.currSelectedTabReportRespArr[i].AffirmationsPicked !== 'null' && this.currSelectedTabReportRespArr[i].AffirmationsPicked !== '' && this.currSelectedTabReportRespArr[i].AffirmationsPicked.length !== 0) ? this.currSelectedTabReportRespArr[i].AffirmationsPicked : 'Not Found'
            this.currSelectedTabReportRespArr[i].IntentionsPicked = (this.currSelectedTabReportRespArr[i].IntentionsPicked !== undefined && this.currSelectedTabReportRespArr[i].IntentionsPicked !== 'undefined' && this.currSelectedTabReportRespArr[i].IntentionsPicked !== null && this.currSelectedTabReportRespArr[i].IntentionsPicked !== 'null' && this.currSelectedTabReportRespArr[i].IntentionsPicked !== '' && this.currSelectedTabReportRespArr[i].IntentionsPicked.length !== 0) ? this.currSelectedTabReportRespArr[i].IntentionsPicked : 'Not Found'
            this.currSelectedTabReportRespArr[i].Meditation = (this.currSelectedTabReportRespArr[i].Meditation !== undefined && this.currSelectedTabReportRespArr[i].Meditation !== 'undefined' && this.currSelectedTabReportRespArr[i].Meditation !== null && this.currSelectedTabReportRespArr[i].Meditation !== 'null' && this.currSelectedTabReportRespArr[i].Meditation !== '' && this.currSelectedTabReportRespArr[i].Meditation.length !== 0) ? this.currSelectedTabReportRespArr[i].Meditation : 'Not Found'
            this.currSelectedTabReportRespArr[i].MeetingTitle = (this.currSelectedTabReportRespArr[i].MeetingTitle !== undefined && this.currSelectedTabReportRespArr[i].MeetingTitle !== 'undefined' && this.currSelectedTabReportRespArr[i].MeetingTitle !== null && this.currSelectedTabReportRespArr[i].MeetingTitle !== 'null' && this.currSelectedTabReportRespArr[i].MeetingTitle !== '' && this.currSelectedTabReportRespArr[i].MeetingTitle.length !== 0) ? this.currSelectedTabReportRespArr[i].MeetingTitle : 'Not Found'
            this.currSelectedTabReportRespArr[i].Wereyouabletoachieveyourgoalatthemeeting = (this.currSelectedTabReportRespArr[i].Wereyouabletoachieveyourgoalatthemeeting !== undefined && this.currSelectedTabReportRespArr[i].Wereyouabletoachieveyourgoalatthemeeting !== 'undefined' && this.currSelectedTabReportRespArr[i].Wereyouabletoachieveyourgoalatthemeeting !== null && this.currSelectedTabReportRespArr[i].Wereyouabletoachieveyourgoalatthemeeting !== 'null' && this.currSelectedTabReportRespArr[i].Wereyouabletoachieveyourgoalatthemeeting !== '' && this.currSelectedTabReportRespArr[i].Wereyouabletoachieveyourgoalatthemeeting.length !== 0) ? this.getUserChallengeRatingInText(this.currSelectedTabReportRespArr[i].Wereyouabletoachieveyourgoalatthemeeting) : 'Not Attempted'
            this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem = (this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== undefined && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== 'undefined' && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== null && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== 'null' && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem !== '' && this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem.length !== 0) ? this.currSelectedTabReportRespArr[i].Whichoftheseactionsdidyouuseatthemeetingandhoweffectivewereyouatusingthem : 'Not Attempted'
          }
          break
      }
      this.bindColumnsNameAndAlias()
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showMeetingMentorReportList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showMeetingMentorReportList = true
        this.exportData()
      }
    },
    getUserChallengeRatingInText: function (currentRating) {
      var valueToReturn = ''
      switch (currentRating) {
        case 1:
          valueToReturn = constants.ReflectionRatingFirstText
          break
        case 2:
          valueToReturn = constants.ReflectionRatingSecondText
          break
        case 3:
          valueToReturn = constants.ReflectionRatingThreeText
          break
        case 4:
          valueToReturn = constants.ReflectionRatingFourText
          break
        case 5:
          valueToReturn = constants.ReflectionRatingFiveText
          break
      }
      return valueToReturn
    },
    exportData: function () {
      return csvHelper.export(this.getCurrSelectedTabReportRespArr, this.columnRespKeyForExport, this.columnAlias, this.csvFileName)
    }
  },
  computed: {
    getCurrSelectedTabReportRespArr: {
      get: function () {
        return this.currSelectedTabReportRespArr
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'meeting-mentor-report'
}
</script>

<style scoped>
.meeting-mentor-report {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.width {
  width: 100% !important;
}
.width1 {
  width: 97.3% !important;
}
.margin-left-0point2Perc {
  margin-left: 0.2% !important;
}
.margin-left-0point4Perc {
  margin-left: 0.4% !important;
}
.margin-left-1point6Perc {
  margin-left: 1.6% !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
.padding-bottom-0Perc{
  padding-bottom: 0px; 
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-left-2point6Perc {
  margin-left: 2.8% !important;
}
.width2 {
  width: 95.2% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/MeetingMentorReport.vue